import React from "react";
import MatchOfTheDayWrapper from "../../../../../dev/terminal/components/matchOfTheDayWrapper";
import Config from "../../../../../dev/config/main";
import { t } from "../../../../../dev/helpers/translator";
import { Link } from "react-router";
import FavoriteCompetitions from "../../../../../dev/terminal/components/favorteCompetitions";
import PopularSports from '../../../../../dev/terminal/components/popularSports';
import SecondPopularSports from "../../../../../dev/terminal/components/secondPopularSports";
import LiveGamesHompage from "../../../../../dev/terminal/components/liveGamesHompage";
import CasinoAndVirtualGameLinks from "../../../../../dev/terminal/components/casinoAndVIrtualGameLinks";

export default function home2Template () {
    let skin = sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem('authData'));
    let skinType = skin.skinType;
    return <div className={`terminal-home v-${Config.homePageView}`}>
        <div className="popular-sports-w">
            <div className="title-f-games-r">
                <h2>Popular Games</h2>
            </div>
            <div className="sports-p-list">
                <PopularSports/>
                {/* {Config.enableTopGames && <Link className="TopGames" to="/topGames/all/all" activeClassName="active"><i>{t("Top games")}</i></Link>} */}
            </div>
        </div>
        <div className="select-features-w">
            <div className="product-list-wrapper-t">
                {
                    Config.headerItems.map((item, i) => {
                        switch (skinType) {
                            case "sport":
                                return (item.enabled && item.name === "Live1" || item.name === "Prematch" || item.name === "Top Games" || item.name === "Today" || item.name === "Virtual Games") && <Link key={i} className={`prod-column-t ${item.url}`} to={`/${item.url}`} activeClassName="active">
                                    {t(item.name)}
                                </Link>;
                            case "casino":
                                return (item.enabled && item.name === "Casino" || item.name === "Live Casino") && <Link key={i} className={`prod-column-t ${item.url}`} to={`/${item.url}`} activeClassName="active">
                                    {t(item.name)}
                                </Link>;
                            default:
                                return (item.enabled && item.name !== "Live" && item.name !== "Top Games" && item.name !== "Casino" && item.name !== "Live Casino") && <Link key={i} className={`prod-column-t ${item.url}`} to={`/${item.url}`} activeClassName="active">
                                    {t(item.name)}
                                </Link>;
                        }
                    })
                }
            </div>
        </div>
        <div className="competitions-sports-w">
            <div className="competitions-list-h">
                <MatchOfTheDayWrapper/>
            </div>
            <div className="casino-and-virtual-game-links">
                <CasinoAndVirtualGameLinks skinType={skinType} selectedProvider={"Betconstruct"} />
            </div>
            <div className="title-f-games-r">
                <h2>Competitions</h2>
            </div>
        </div>
    </div>;
};